import { Button, Input, Select, Textarea } from '@/components'
import { useAppSelector } from '@/redux/hooks'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import {
  BoardListItem,
  buttonName,
  confirmMessages,
  fieldMessages,
  options,
  successMessages,
} from '../../boardItem'

type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

type FormData = {
  nttSj: string
  nttCn: string
  bbsSj: string
}

type UpdateProps = {
  boardDetail: BoardListItem | null
}

export const CommunityUpdateBoard: React.FC<UpdateProps> = ({
  boardDetail,
}) => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const { showAlert, showConfirm } = useDialog()
  const { user } = useAppSelector((state) => state.auth)
  const [formData, setFormData] = useState({
    nttSn: boardDetail?.nttSn,
    bbsTy: boardDetail?.bbsTy,
    nttSj: boardDetail?.nttSj,
    nttCn: boardDetail?.nttCn,
    bbsSj: boardDetail?.bbsSj,
    cstId: user?.cstId,
    regId: user?.cstId,
    updId: user?.cstId,
  })

  const handleChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target as HTMLInputElement | HTMLTextAreaElement // 타입 캐스팅
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleModalAction = (type: 'save' | 'cancel') => {
    if (type === 'cancel') {
      showConfirm({
        title: confirmMessages.cancel,
        confirmBtnName: buttonName.confirm,
        cancelBtnName: buttonName.cancel,
        onConfirm() {
          setTimeout(() => {
            navigate(0) // 500ms 후에 페이지 이동
          }, 100)
        },
      })
    }

    if (type === 'save') {
      const requiredFields: { field: keyof FormData; message: string }[] = [
        { field: 'bbsSj', message: fieldMessages.bbsSj },
        { field: 'nttSj', message: fieldMessages.nttSj },
        { field: 'nttCn', message: fieldMessages.nttCn },
      ]

      // 필수 입력값 확인
      for (const { field, message } of requiredFields) {
        const value = formData[field]

        if (typeof value === 'string' && !value.trim()) {
          showAlert({
            type: 'warning',
            message: message,
          })
          return
        }
      }

      showConfirm({
        title: confirmMessages.insert,
        confirmBtnName: buttonName.confirm,
        cancelBtnName: buttonName.cancel,
        onConfirm() {
          updateBoard()
        },
      })
    }
  }
  const updateBoard = async () => {
    try {
      await axios.post(`/community/update`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      showAlert({
        type: 'success',
        title: successMessages.update,
        btnName: buttonName.confirm,
        onClose() {
          setTimeout(() => {
            navigate(0)
          }, 100)
        },
      })
    } catch (err: any) {
      console.error('Error updating board:', err)
    }
  }

  return (
    <>
      <div
        style={{
          marginBottom: '10px',
          display: 'flex',
          gap: '5px',
        }}
      >
        <Select
          id="bbsSj"
          name="bbsSj"
          width="200px"
          value={formData?.bbsSj}
          onChange={handleChange}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
        <Input
          id="nttSj"
          name="nttSj"
          maxLength={255}
          placeholder="제목을 입력하세요."
          value={formData.nttSj}
          onChange={handleChange}
        />
      </div>
      <div
        style={{
          marginBottom: '10px',
        }}
      >
        <Textarea
          id="nttCn"
          name="nttCn"
          width={'100%'}
          height={'500px'}
          placeholder="내용을 입력하세요."
          state="success"
          value={formData.nttCn}
          onChange={handleChange}
        />
      </div>

      <div style={{ display: 'flex', marginBottom: '10px' }}>
        <div style={{ marginLeft: 'auto' }}>
          <div style={{ display: 'flex', gap: '5px' }}>
            <Button color="neverbe" onClick={() => handleModalAction('save')}>
              저장
            </Button>
            <Button color="neverbe" onClick={() => handleModalAction('cancel')}>
              취소
            </Button>
            <Button
              color="neverbe"
              onClick={() => navigate(`/community`, { state: location.state })}
            >
              목록
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
